import { makeStyles } from "@material-ui/core";
import { Typography, Box } from "@mui/material";
import { useState } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import SubmitLoader from "src/components/SubmitLoader";
import {
  CancelButton,
  RdxAutocompleteField,
  RdxCheckBox,
  RdxTextField,
  SubmitButton,
} from "src/components/form/InputFields";
import { data } from "src/mock/address";
import * as yup from "yup";

const validationSchema = yup.object().shape({
  meterNumber: yup.string().nullable().max(10).required(),
  address: yup.string().nullable().required(),
  consent: yup.boolean().nullable().oneOf([true]).required(),
});

const validate = (values) => {
  const formErrors = {};

  try {
    validationSchema.validateSync(values, { abortEarly: false });
  } catch (errors) {
    errors.inner.forEach((error) => {
      formErrors[error.path] = error.message;
    });
  }

  return formErrors;
};

let TestForm = (props) => {
  const classes = useStyles();
  const { handleSubmit, pristine } = props;
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (values) => {
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
    }, 2000);
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box className={classes.root}>
        <Typography variant="h2">Test Form</Typography>
        <Field
          name="meterNumber"
          width={100}
          label="Meter Number"
          placeholder="Type your Meter Number"
          component={RdxTextField}
        />
        <Field
          name="address"
          width={100}
          label="Address"
          placeholder="Type your Address"
          component={RdxAutocompleteField}
          options={data}
        />
        <Box className={classes.consents}>
          <Field name="copy" component={RdxCheckBox}>
            Would you like to receive a copy of the consent?
          </Field>
          <Field name="consent" component={RdxCheckBox}>
            By checking the box, I agree to grant BKV Energy permission to
            access my account on Smart Meter Texas (SMT). In addition, BKV
            Energy shall provide all SMT e-mail communications received by BKV
            Energy on your behalf to your e-mail address provided.
          </Field>
        </Box>
        <Box className={classes.buttonBox}>
          <CancelButton disabled={submitting}>Back</CancelButton>
          <SubmitButton type="submit" disabled={pristine || submitting}>
            Continue
          </SubmitButton>
        </Box>
        <SubmitLoader open={submitting} />
      </Box>
    </form>
  );
};

TestForm = reduxForm({
  form: "TestForm",
  validate,
  initialValues: {
    consent: false,
  },
})(TestForm);
const selector = formValueSelector("TestForm");
// TestForm = connect(state => {
//     const consent = selector(state, 'consent')
//     return {
//         consent
//     }
// })(TestForm)

export default TestForm;

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "2% 5%",
    maxWidth: 757,
  },
  consents: {
    marginTop: 24,
    display: "flex",
    flexDirection: "column",
    gap: 20,
  },
  buttonBox: {
    marginTop: 50,
    display: "flex",
    gap: 30,
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
    },
  },
}));
